import { Component, EventEmitter, Input, OnInit, Optional, Output, Self } from '@angular/core';
import { AbstractControl, NgControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Component({
  selector: 'app-hint-field',
  templateUrl: './hint-field.component.html',
  styleUrls: ['./hint-field.component.scss']
})
export class HintFieldComponent implements OnInit {

  @Input() label?: string;
  @Input() letters?: number;
  @Input() minLength?: number;
  @Input() numbers?: number;
  @Input() hint?: boolean;
  specialCharacter?: number = 0;

  @Output() onFocus = new EventEmitter<void>(true);
  @Output() onBlur = new EventEmitter<void>(true);
  @Output() onChange = new EventEmitter<string>(true);

  showPassword = false;
  lettersValid = false;
  minLengthValid = false;
  numbersValid = false;
  specialCharacterValid = true;

  private _controlValidators?: ValidatorFn[];

  constructor(@Self() @Optional() private ngControl: NgControl) { }

  ngOnInit() {
    if (this.ngControl.control) {
      this._controlValidators = [
        this.getValidator(control => this.checkLettersValid(control.value), "letters", `Informe no mínimo ${this.letters} letra${this.letters && this.letters > 1 ? "s" : ""}`),
        this.getValidator(control => this.checkMinLengthValid(control.value), "minLength", `Informe no mínimo ${this.minLength} dígito${this.minLength && this.minLength > 1 ? "s" : ""}`),
        this.getValidator(control => this.checkNumbersValid(control.value), "numbers", `Informe no mínimo ${this.numbers} número${this.numbers && this.numbers > 1 ? "s" : ""}`),
        this.getValidator(control => this.checkSpecialCharacterValid(control.value), "specialCharacter", `Use somente letras e números`)
      ];

      this.ngControl.control.addValidators(this._controlValidators!);
      this.ngControl.control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
    }
  }

  ngOnDestroy() {
    if (this._controlValidators) {
      this.ngControl?.control?.removeValidators(this._controlValidators);
    }
  }

  handleChangeEvent(value: any): void {
    this.onChange.emit(value);
    this.checkValidity(value);
  }

  handleFocusEvent(): void {
    this.onFocus.emit();
  }

  handleBlurEvent(): void {
    this.onBlur.emit();
  }

  private checkValidity(value: any) {
    const password = String(value ?? '');
    this.lettersValid = this.checkLettersValid(password);
    this.minLengthValid = this.checkMinLengthValid(password);
    this.numbersValid = this.checkNumbersValid(password);
    this.specialCharacterValid = this.checkSpecialCharacterValid(password);
  }

  private checkLettersValid(value: string): boolean {
    return !(typeof this.letters === "number" && this.letters > 0) || (typeof value === "string" && Number(value.match(/[a-zA-Z]/g)?.length) >= this.letters);
  }

  private checkMinLengthValid(value: string): boolean {
    return !(typeof this.minLength === "number" && this.minLength > 0) || (typeof value === "string" && value.length >= this.minLength);
  }

  private checkNumbersValid(value: string): boolean {
    return !(typeof this.numbers === "number" && this.numbers > 0) || (typeof value === "string" && Number(value.match(/[0-9]/g)?.length) >= this.numbers);
  }

  private checkSpecialCharacterValid(value: string): boolean{
    return /^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ ]+$/g.test(value);
  }

  private getValidator(validatorFn: (control: AbstractControl) => boolean, ruleName: string, message: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return validatorFn(control) === true ? null : { [ruleName]: true, message };
    };
  }

}
